import type { FileTableColumnField } from '@/components/Views/Company/File/file-table.types';
import { FILE_TABLE_COLUMNS } from '@/components/Views/Company/File/file-table.types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFileTablePreferenceStore = defineStore(
    'fileTablePreference',
    () => {
        const visibleFields = ref<FileTableColumnField[]>(
            FILE_TABLE_COLUMNS.filter(column => !column.hiddenByDefault).map(column => column.field),
        );
        return {
            visibleFields,
        };
    },
    {
        persist: true,
    },
);
